const EditorPermissions = {
  FULL: 'EditorPermissions.FULL',
  READ_ONLY: 'EditorPermissions.READ_ONLY',
  NONE: 'EditorPermissions.NONE'
};

export default EditorPermissions;
